<template>
  <div class="container common-card-margin f-c" v-loading="loadingData">
    <div class="functions-board">
      <shipment-stats :shipment="shipment" :pallets="pallets" class="statis" />
      <div class="f-r-vc detail-page-basic-info" style="gap: 20px; flex-wrap: wrap">
        <span class="entity-no">{{ shipmentNo }}</span>
        <el-tag :type="shipmentStatusTag" effect="dark">{{
          shipmentStatus
          }}</el-tag>
        <el-progress :percentage="loadedProgress" :stroke-width="26" :format="progressFormat" />
      </div>
    </div>
    <div class="features f-r">
      <el-button type="success" class="feature-secondary" @click="goToShipmentBol(shipmentNo)"
        :disabled="shipmentStatus === ShipmentDeleted" v-if="palletIds.length > 0">
        <svg-icon icon-class="info" class="svg-white-color" style="font-size: 18px" />
        Create BOL
      </el-button>
      <el-button type="success" class="feature-secondary" @click="previewShipmentReceipt()"
        :disabled="shipmentStatus === ShipmentDeleted || palletIds.length === 0">
        <svg-icon icon-class="print" class="svg-white-color" style="font-size: 18px" />
        Shipment Receipt
      </el-button>
      <el-button type="success" class="feature-secondary" @click="changeStage"
        :disabled="shipmentStatus === ShipmentDeleted" v-if="ShipmentWorking === shipmentStatus">
        <svg-icon icon-class="pencil" class="svg-white-color" style="font-size: 15px" />
        Set Staging Area
      </el-button>
      <el-button type="success" class="feature-secondary" :disabled="shipmentStatus === ShipmentDeleted"
        @click="changePort" v-if="ShipmentWorking === shipmentStatus">
        <svg-icon icon-class="pencil" class="svg-white-color" style="font-size: 15px" />
        Set Truck Dock
      </el-button>
      <el-button type="success" class="feature-secondary" @click="setPickUpdate"
        v-if="ShipmentWorking === shipmentStatus">
        <svg-icon icon-class="pencil" class="svg-white-color" style="font-size: 15px" />
        Set Pick Up Date
      </el-button>
      <el-button type="warning" class="feature-secondary" @click="
        goToStock({
          mode: ShipmentModes.ShipmentUpdate,
          no: shipmentNo
        })
        " v-if="ShipmentWorking === shipmentStatus">
        <svg-icon icon-class="pencil" class="svg-white-color" style="font-size: 15px" />
        Modify Shipment
      </el-button>
      <el-button v-if="ShipmentWorking === shipmentStatus" type="warning" class="feature-secondary"
        @click="openReadyShipment">
        <svg-icon icon-class="info" class="svg-white-color" style="font-size: 18px" />
        Ready Shipment
      </el-button>
      <el-button v-if="ShipmentShipping === shipmentStatus" type="warning" class="feature-secondary"
        @click="openReportShipping">
        <svg-icon icon-class="info" class="svg-white-color" style="font-size: 18px" />
        Report Shipping
      </el-button>
      <el-button type="danger" class="feature-secondary" @click="openDeleteConfirm"
        v-if="ShipmentWorking === shipmentStatus">
        <svg-icon icon-class="trash" class="svg-white-color" style="font-size: 15px" />
        Delete Shipment
      </el-button>
      <el-button type="info" class="feature-secondary" @click="openQrCode">
        <svg-icon icon-class="info" class="svg-white-color" style="font-size: 18px" />
        QR Code
      </el-button>
    </div>
    <div class="f-r first-row">
      <div class="f-c left">
        <shipment-info class="info" :shipment-no="shipmentNo" :shipment="shipment" :mode="FormModes.LOOSE" />
        <pick-up-info :shipment-no="shipmentNo" :shipment="shipment" :mode="FormModes.LOOSE" />
      </div>
      <shipment-progress v-if="shipment" class="right" :shipment="shipment" :pallets="pallets" />
    </div>
    <div class="tabs">
      <el-tabs v-model="selectedTab" @tab-click="selectTabChange">
        <el-tab-pane label="Pallets" name="PalletsTab">
          <pallet-list class="pallet-list" :palletQuery="palletIds.length > 0 ? { ids: palletIds } : null"
            :excludeCols="['hold']" :showGroupName="true" :rowClassName="palletListRowClass" />
        </el-tab-pane>
        <el-tab-pane label="Orders" name="OrdersTab">
          <stock-list :showActions="false" :stockQuery="stockQuery" :showHeaderOps="false"
            :excludeCols="['shippedDate', 'shipmentNo', 'unloadingJobNo']" :summary="false" />
        </el-tab-pane>
        <el-tab-pane label="Jobs" name="JobsTab">
          <job-list :jobQuery="jobIds.length > 0 ? { ids: jobIds } : null" />
        </el-tab-pane>
        <el-tab-pane label="Notes" name="NotesTab">
          <shipment-note-list v-if="shipmentId" :shipmentId="shipmentId" :disabled="shipmentStatus === ShipmentDeleted"
            :notes="notes" :change-cb="modifyNotes" />
        </el-tab-pane>
        <el-tab-pane label="Tracking" name="TrackingsTab">
          <TrackingRecords :recordQuery="recordQuery" :shipment-id="shipmentId" />
        </el-tab-pane>
      </el-tabs>
    </div>
    <common-dialog ref="qrCode" class="qr-code" title="QR Code">
      <template v-slot:content>
        <img :src="shipmentQrSrc" />
      </template>
    </common-dialog>
    <change-port ref="changePortDialog" :shipment="shipment" />
    <change-stage ref="changeStageDialog" :shipment="shipment" />
    <ready-shipment ref="readyShipment" />
    <set-pick-up-date ref="changePickUpDateDialog" :shipment="shipment" />
    <confirm ref="deleteConfirm" :title="'Delete Shipment ' + shipmentNo" :confirmCb="shipmentDelete">
      <template v-slot:content>
        <div class="f-c confirm-delete-hint">
          <span>
            1. All pallets in shipment will become OffStack after deletion!
          </span>
          <span>2. Shipment cannot be recovered after deletion!</span>
          <span>3. Shipment cannot be modified after deletion!</span>
          <span></span>
        </div>
      </template>
    </confirm>
    <BusinessOrderShippingReport v-if="shipmentNo != null" ref="reportConfirm" :shipmentNo="shipmentNo" />
  </div>
</template>
<script>
// components
import ShipmentStats from '@/components/shipment/ShipmentStats.vue'
import ShipmentInfo from '@/components/shipment/ShipmentInfo.vue'
import ShipmentProgress from '@/components/shipment/ShipmentProgress.vue'
import PickUpInfo from '@/components/shipment/PickUpInfo.vue'
import PalletList from '@/components/pallet/PalletList.vue'
import StockList from '@/components/shipment/StockList.vue'
import JobList from '@/components/jobs/JobList.vue'
import TrackingRecords from '@/components/tracking/TrackingRecords.vue'
import ShipmentNoteList from '@/components/note/ShipmentNoteList.vue'
import CommonDialog from '@/components/common/CommonDialog.vue'
import ChangePort from '@/components/shipment/ChangePort.vue'
import ChangeStage from '@/components/shipment/ChangeStage.vue'
import ReadyShipment from '@/components/shipment/ReadyShipment.vue'
import SetPickUpDate from '@/components/shipment/SetPickUpDate.vue'
import Confirm from '@/components/common/Confirm.vue'
// apis
import {
  deleteShipment,
  detailShipment,
  modifyShipment,
  shipmentInstruction
} from '@/api/shipment'
import { labelPallet, queryPallets } from '@/api/pallet'
import { queryOrders } from '@/api/order'
import { queryJobs } from '@/api/job'
// models
import { FormModes } from '@/core/configs/types'
import {
  ShipmentWorking,
  ShipmentDeleted,
  ShipmentModes,
  ShipmentDelivered,
  ShipmentShipping
  // ConfirmationModes
} from '@/core/models/shipment'
// mixins
import { pageJumps } from '@/core/mixin/pages'
// msg
import PagesMessage from '@/core/message/pages'
// utils
import { viewPdf } from '@/core/utils'
import BusinessOrderShippingReport from '@/components/shipment/BusinessOrderShippingReport.vue'

const QRCode = require('qrcode')

export default {
  name: 'ShipmentDetail',
  mixins: [pageJumps],
  components: {
    ShipmentStats,
    ShipmentInfo,
    PickUpInfo,
    PalletList,
    StockList,
    JobList,
    TrackingRecords,
    ShipmentNoteList,
    CommonDialog,
    ShipmentProgress,
    ChangePort,
    ChangeStage,
    ReadyShipment,
    SetPickUpDate,
    Confirm,
    BusinessOrderShippingReport
  },
  data() {
    return {
      FormModes,
      ShipmentWorking,
      ShipmentDeleted,
      ShipmentShipping,
      loadingData: false,
      shipment: null,
      jobs: [],
      ShipmentModes,
      mode: ShipmentModes.ShipmentCreation,
      shipmentQrSrc: '',
      pallets: []
    }
  },
  computed: {
    shipmentNo() {
      return this.$route.params.no
    },
    shipmentId() {
      return this.shipment?.id ?? ''
    },
    shipmentStatus() {
      return this.shipment?.status ?? ''
    },
    isShipmentReady() {
      return (
        this.palletIds.length > 0 &&
        this.palletIds.length === this.shipment?.loadedPalletIds.length
      )
    },
    shipmentStatusTag() {
      switch (this.shipmentStatus) {
        case ShipmentDeleted:
          return 'danger'
        case ShipmentDelivered:
          return 'success'
        default:
          return 'primary'
      }
    },
    notes() {
      return this.shipment?.notes ?? []
    },
    palletIds() {
      return this.shipment?.palletIds ?? []
    },
    loadedPalletIds() {
      return this.shipment?.loadedPalletIds ?? []
    },
    deletedPalletIds() {
      return this.shipment?.deletedPalletIds ?? []
    },
    loadedProgress() {
      if (this.palletIds.length === 0) return 0
      return (this.loadedPalletIds.length / this.palletIds.length) * 100
    },
    orderIds() {
      return this.shipment?.orderIds ?? []
    },
    jobIds() {
      return this.shipment?.jobIds ?? []
    },
    selectedTab: {
      get() {
        return this.$route.query.tab
      },
      set(value) {
        this.goToShipmentDetail(this.shipmentNo, { tab: value })
      }
    },
    stockQuery() {
      if (this.shipmentId === '') return {}
      return {
        shipmentId: this.shipmentId,
        onlyShipped: true
      }
    },
    recordQuery() {
      return {
        shipmentIds: [this.shipmentId]
      }
    }
  },
  methods: {
    async getShipmentDetail() {
      this.loadingData = true
      const shipment = await detailShipment(this.shipmentNo)
      this.loadingData = false
      this.$set(this, 'shipment', shipment)
      const palletIds = shipment.palletIds
      if (palletIds.length > 0) {
        const pallets =
          (await queryPallets({ ids: palletIds, size: -1 }))?.records ?? []
        this.$set(this, 'pallets', pallets)
      }
    },
    getShipmentOrders() {
      if (this.orderIds.length > 0) {
        queryOrders({ ids: this.orderIds }).then(res => {
          this.orders = res
          this.orders.forEach(order => {
            order.palletCnt = this.pallets.filter(
              pallet => pallet.orderId === order.id
            ).length
          })
        })
      }
    },
    getShipmentJobs() {
      if (this.jobIds.length > 0) {
        queryJobs({ ids: this.jobIds }).then(res => {
          this.jobs = res
        })
      }
    },
    selectTabChange() { },
    modifyNotes(notes) {
      modifyShipment(this.shipmentId, { notes }).then(res => {
        PagesMessage.emit(PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL)
      })
    },
    removePallets() {
      this.$refs.removePalletsDialog.open()
    },
    toDeletePallet(pallet) {
      this.toDelete.push(pallet)
    },
    openDeleteConfirm() {
      this.$refs.deleteConfirm.open()
    },
    shipmentDelete(done, error) {
      deleteShipment(this.shipmentNo)
        .then(res => {
          this.getShipmentDetail()
          done()
        })
        .catch(err => {
          error(err)
        })
    },
    toModifyShipment() {
      this.goToStock({
        mode: ShipmentModes.ShipmentUpdate,
        no: this.shipmentNo
      })
    },
    async getShipmentQrSrc() {
      const src = await QRCode.toDataURL(
        JSON.stringify({
          type: 'Shipment',
          id: this.shipmentId
        }),
        {
          margin: 0,
          width: 170,
          height: 170
        }
      )
      this.shipmentQrSrc = src
    },
    openQrCode() {
      this.getShipmentQrSrc().then(e => this.$refs.qrCode.open())
    },
    async labelPallet(palletNo) {
      // download pallet labels
      const blob = await labelPallet(palletNo)
      viewPdf(blob)
    },
    changePort() {
      this.$refs.changePortDialog.open()
    },
    changeStage() {
      this.$refs.changeStageDialog.open()
    },
    setPickUpdate() {
      this.$refs.changePickUpDateDialog.open()
    },
    openReadyShipment() {
      this.$refs.readyShipment.open(this.shipmentNo, this.getShipmentDetail)
    },
    openReportShipping() {
      this.$refs.reportConfirm.open()
    },
    async previewShipmentReceipt() {
      shipmentInstruction(this.shipmentId)
        .then(res => {
          viewPdf(res)
        })
        .catch(err => {
          viewPdf(err.response.data)
        })
    },
    palletListRowClass(row) {
      if (
        this.shipmentStatus === ShipmentWorking &&
        this.shipment.loadedPalletIds.includes(row.id)
      ) {
        return 'pallet-loaded-row'
      }
      return ''
    },
    progressFormat() {
      return `${this.loadedPalletIds.length}/${this.palletIds.length} Load`
    },
    setASN(orderNo, asnNumber) {
      this.asnInputMap[orderNo] = asnNumber
    }
  },
  watch: {
  },
  mounted() {
    if (this.shipmentNo) {
      this.getShipmentDetail()
    }
    PagesMessage.on(
      PagesMessage.eventMap.REFRESH_SHIPMENT_DETAIL,
      this.getShipmentDetail
    )
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.functions-board {
  .el-button {
    border: none;
  }

  @extend .f-c;

  gap: 20px;
  justify-content: space-between;
}

.container {
  width: calc(100% - 40px);
  margin: 10px 20px;
  gap: 20px;

  .common-card {
    margin: 0 !important;
  }
}

.tabs {
  @extend .shadow-level-three;

  border-radius: $home-card-border-radius;
  padding: $home-card-padding-y $home-card-padding-x;
  background-color: white;
}

.first-row {
  gap: 20px;

  .left {
    width: 70%;
    gap: 20px;
  }

  .right {
    width: 30%;
  }
}

.to-delete-list {
  gap: 20px;

  .delete-item {
    padding: 10px 20px;
    background: white;
    border-radius: 4px;

    @extend .shadow-level-three;

    span {
      text-decoration: line-through;
    }
  }
}

::v-deep .qr-code {
  .el-dialog__body {
    @extend .f-r-c-c;
  }
}

.confirm-delete-hint {
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  margin-bottom: 10px;
  gap: 5px;
  padding: 10px;
  color: rgba($deep-danger, 0.6);
  word-break: break-word;
}

.features {
  gap: 10px;
  flex-wrap: wrap;

  .el-button {
    margin-left: 0;
  }
}

.el-progress {
  width: 600px;
  margin: 0 !important;

  @extend .f-r;

  align-items: center;

  ::v-deep .el-progress__text {
    white-space: nowrap;
    color: black;
    font-size: 42px !important;
    font-weight: bolder;
    margin-left: 20px;
    font-family: 'oswald bold', sans-serif;
  }

  ::v-deep .el-progress-bar {
    .el-progress-bar__outer {
      height: 36px !important;

      @extend .shadow-level-one;

      .el-progress-bar__inner {
        background-color: $business-color;
      }
    }
  }
}

.ans-form-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 10px;

  .po-no {
    font-size: 16px;
    font-weight: bold;
  }

  .asn-input {
    width: 168px;
  }
}
</style>
